// src/components/BrandLogo.js
import React from "react";
import { Box } from "@mui/material";
import logo from "../assets/logo-filled.png";

/**
 * Centered brand logo used above auth/pairing screens.
 * Keep usage consistent across pages for a uniform look.
 */
export default function BrandLogo({ size = 100, mb = 4, alt = "KBEAN TV" }) {
  return (
    <Box sx={{ width: "100%", display: "flex", justifyContent: "center", mb }}>
      <Box
        component="img"
        src={logo}
        alt={alt}
        draggable={false}
        sx={{
          width: size,
          height: "auto",
          display: "block",
          userSelect: "none",
          pointerEvents: "none",
        }}
      />
    </Box>
  );
}
